import DeviceModules from 'src/content/management/Devices/module';
import registerModulesWithRouter from 'src/config/AccessControl/registerModulesWithRouter';
import VehicleModules from 'src/content/management/Vehicles/module';
import GeofenceModules from 'src/content/management/GeoFences/module';
import UserModules from 'src/content/management/Users/module';
import POIModules from 'src/content/management/POI/module';
import RoleModules from 'src/content/management/Role/module';
import ItemModules from 'src/content/management/Item/module';
import OrganisationModules from 'src/content/management/Organisation/module';
import WalletModules from 'src/content/management/Wallet/module';
import VehicleStatusDashboardModules from 'src/content/dashboards/VehicleStatus/module';
import GroupsModules from 'src/content/management/Groups/module';
import { privateCertificateRoutes } from './certificate.route';

// Management

const managementRoutes = [
  registerModulesWithRouter(DeviceModules),
  registerModulesWithRouter(GeofenceModules),
  registerModulesWithRouter(RoleModules),
  registerModulesWithRouter(OrganisationModules),
  registerModulesWithRouter(ItemModules),
  registerModulesWithRouter(VehicleModules),
  registerModulesWithRouter(VehicleStatusDashboardModules),
  registerModulesWithRouter(UserModules),
  registerModulesWithRouter(WalletModules),
  registerModulesWithRouter(GroupsModules),
  registerModulesWithRouter(POIModules),
  {
    path: '/certificate',
    children: privateCertificateRoutes
  }
];

export default managementRoutes;
